import { Chip, Tooltip, useTheme } from "@mui/material";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faPause, faPlay, IconDefinition } from "@fortawesome/sharp-solid-svg-icons";
import { Box } from "../../platform-style";

import { setStatusStyle, StatusColors, Statuses } from "./statusUtils";

// TODO: This component needs a complete rework once legacy support is no longer required

export type StatusChipIcon = "play" | "pause" | "check";

export interface StatusChip {
  Status?: Statuses;
  Text?: string;
  Icon?: StatusChipIcon | IconDefinition;
  ToolTip?: string;
  status?: Statuses;
  label?: string;
  icon?: StatusChipIcon | IconDefinition;
  toolTip?: string;
  size?: "small" | "medium" | "large";
}

export interface StatusChipProps {
  status?: Statuses;
  label?: string;
  icon?: StatusChipIcon | IconDefinition;
  toolTip?: string;
  size?: "small" | "medium" | "large";
  //To be deleted after example commands is updated
  Status?: Statuses;
  Text?: string;
  Icon?: StatusChipIcon | IconDefinition;
  ToolTip?: string;
}

function getIconElement(icon: StatusChipIcon | IconDefinition): IconDefinition {
  switch (icon) {
    case "play":
      return faPlay;
    case "pause":
      return faPause;
    case "check":
      return faCheck;
    default:
      return icon;
  }
}

export const StatusChip = (props: StatusChipProps) => {
  const theme = useTheme();

  function getStyle(color: Statuses): StatusColors {
    let returnColor: StatusColors = {};
    return setStatusStyle(color, returnColor, theme);
  }

  return (
    <Tooltip title={props.toolTip} key={props.label}>
      <Chip
        label={props.label}
        icon={
          props.icon && (
            <Box sx={{ pl: "6px", pr: "2px" }}>
              <FontAwesomeIcon icon={getIconElement(props.icon)} color={"black"} />
            </Box>
          )
        }
        variant="outlined"
        sx={{
          color: "primary.main",
          m: "2px",
          fontWeight: "700",
          height:
            props.size == undefined || props.size == "medium"
              ? "30px"
              : props.size == "small"
              ? "24px"
              : "36px",
          ...getStyle(props.status ?? "default"),
        }}
      />
    </Tooltip>
  );
};
